export default __webpack_public_path__ + "static/media/WAN.668a2025.svg";